import { Fragment, useEffect, useState } from 'react';
import { CommonLoading } from 'react-loadingg';
import { QREventHeader, QREvents } from '.';

const QREvent = (props) => {
    const [cognitoUsers, setCognitoUsers] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('QR Event') &&
                        item.permissionType.includes('view'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }
        }
    }, [props.loginList]);

    useEffect(() => {
        const getEventList = async () => {
            const eventListFromServer = await fetchCognitoUsers();
            setCognitoUsers(eventListFromServer);
        };

        getEventList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchCognitoUsers = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/report/getqreventlist'
        );
        const data = await res.json();
        
        return data.EventList;
    };

    const QREventList = () => {
        return (
            <Fragment>
                {cognitoUsers.length > 0 ? (
                    <QREvents users={cognitoUsers} />
                ) : (
                    <div>No users has been created</div>
                )}
            </Fragment>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <QREventHeader />
                        {/* <p style={{ marginLeft: '5px' }}>
                            NOT Applicable to Active Directory User
                        </p> */}
                        <div className='table-wrapper'>
                            <QREventList />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default QREvent;
